/**
 * @file Auction group CRUD and manifest-statistics API helpers (credentialed client).
 */

import client from './client';

export const getAuctionGroups = async () => {
  try {
    const response = await client.get('/auction-groups');

    // Ensure we return an array
    if (Array.isArray(response.data)) {
      return response.data;
    } else if (response.data && Array.isArray(response.data.data)) {
      // Sometimes APIs wrap data in a data property
      return response.data.data;
    } else {
      console.error('Unexpected API response format:', response.data);
      return []; // Return empty array as fallback
    }
  } catch (error) {
    console.error('Error fetching auction groups:', error);
    throw error; // Re-throw to let React Query handle it
  }
};

export const getAuctionGroupById = async (id) => {
  const response = await client.get(`/auction-groups/${id}`);
  return response.data;
};

/** Pickup progress already recorded in a group (picks, load-outs, scans). */
export const getMergePreflight = async (auctionGroupId) => {
  const response = await client.get(`/auction-groups/${auctionGroupId}/merge-preflight`);
  return response.data;
};

export const createAuctionGroup = async (title) => {
  try {
    console.log('API: Creating auction group with title:', title);
    const response = await client.post('/auction-groups', { title });
    console.log('API: Response received:', response);
    console.log('API: Response data:', response.data);
    return response.data;
  } catch (error) {
    console.error('API: Error creating auction group:', error);
    console.error('API: Error response:', error.response);
    throw error;
  }
};

export const updateAuctionGroup = async (id, title) => {
  const response = await client.put(`/auction-groups/${id}`, { title });
  return response.data;
};

export const deleteAuctionGroup = async (id) => {
  const response = await client.delete(`/auction-groups/${id}`);
  return response.data;
};

export const getManifestStatistics = async (auctionGroupId) => {
  const response = await client.get(`/auction-groups/${auctionGroupId}/manifest-statistics`);
  return response.data;
};

export const getLotsWithoutManifest = async (auctionGroupId, limit = null) => {
  const url = limit != null && limit > 0
    ? `/auction-groups/${auctionGroupId}/lots-without-manifest?limit=${limit}`
    : `/auction-groups/${auctionGroupId}/lots-without-manifest`;
  const response = await client.get(url);
  return response.data;
};

